// extracted by mini-css-extract-plugin
export default {"invoice_container":"invoice_invoice_container__X5o5n"};